import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Grussworte from "@/components/Grussworte";
import Geschichte from "@/components/Geschichte";
import Statistics from "@/components/Statistics";
import Tlf3000 from "@/components/Tlf3000";
import Fuhrpark from "@/components/Fuhrpark";
import Einsatzchronik from "@/components/Einsatzchronik";
import Team from "@/components/Team";
import Jugend from "@/components/Jugend";
import Vereinsleben from "@/components/Vereinsleben";
import Mitglied from "@/components/Mitglied";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Grussworte />
      <Geschichte />
      <Statistics />
      <Tlf3000 />
      <Fuhrpark />
      <Einsatzchronik />
      <Team />
      <Jugend />
      <Vereinsleben />
      <Mitglied />
      <Footer />
    </main>
  );
}
